export const generatedShorterLink = ({ state }) => state.shorterLinks.generatedShorterLink;
export const getShorterLinksListData = ({ state }) => state.shorterLinks.shorterLinksData;
